import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from "../OneModal/OneModal"
import EquipeUsuario from '../EquipeUsuario/EquipeUsuario'

const EquipeUsuarioModal = ({ open, setOpen, dado }) => {
    return (
        <>
            <OneModal
                open={open}
                setOpen={setOpen}
                onClose={false}
                titleText= {`Liberação para usuário:  ${dado.nome} `}
                height = {true}
                width = {true}
                dado = {dado}
            >
                <Grid container sx={{ display: 'inline-block', justifyContent: 'left', alignItems: 'left', height: '100%', width: '100%' }}>
                    <EquipeUsuario dadosUsuario = {dado}/>
                </Grid>
            </OneModal>
        </>
    )
}

export default EquipeUsuarioModal
